const TARGET_LIST_TITLE = 'The Vault';
const PARAM_KEY = 'view';
const PARAM_VALUE = 'look-book';

function ready(callback) {
    if (document.readyState !== 'loading') {
        callback();
        return;
    }

    document.addEventListener('DOMContentLoaded', callback);
}

function appendParamToHref(href, key, value) {
    if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
        return href;
    }

    const url = new URL(href, window.location.origin);
    url.searchParams.set(key, value);

    if (href.startsWith('/')) {
        return `${url.pathname}${url.search}${url.hash}`;
    }

    return url.toString();
}

function isTargetFooterList(block, targetTitle) {
    const titleEl = block.querySelector('.v-stack > p, p.h6, p');
    if (!titleEl) {
        return false;
    }

    return titleEl.textContent.trim() === targetTitle;
}

function mutateLinks() {
    console.log("Document Ready!\nMutationg footer links...");
    const footer = document.querySelector('.footer__block-list');
    if (!footer) {
        return;
    }

    const linkBlocks = footer.querySelectorAll('.footer__block--links');

    linkBlocks.forEach((block) => {
        console.log("Seacrhing for:" + TARGET_LIST_TITLE);
        if (!isTargetFooterList(block, TARGET_LIST_TITLE)) {
            return;
        }
        console.log(TARGET_LIST_TITLE + " Found!");
        const links = block.querySelectorAll('ul li a[href]');
        links.forEach((link) => {
            const updatedHref = appendParamToHref(link.getAttribute('href'), PARAM_KEY, PARAM_VALUE);
            console.log("Updated '" + link.getAttribute('href') + "' to '" + updatedHref );
            if (updatedHref) {
                link.setAttribute('href', updatedHref);
            }
        });
    });
}

ready(mutateLinks);
